import apiWrapper, { extractApiData } from 'Helpers/apiWrapper'

const endpoints = ((baseURL) => {
  return {
    getAccountConfiguration: `${baseURL}/api/account/configuration`,
    getAccountDataRetention: `${baseURL}/api/account/dataretention`,

    getUserById: (idUser) =>
      `${baseURL}/api/user/${encodeURIComponent(idUser)}`,
    getOptionByShortName: (shortName) =>
      `${baseURL}/api/option/${encodeURIComponent(shortName)}`,
    getOptions: `${baseURL}/api/options`,
  }
})(process.env.BEACCOUNTS_URL)

export const beAccountsApiGetAccountConfiguration = () => {
  const url = endpoints.getAccountConfiguration
  return apiWrapper({
    method: 'get',
    url,
  }).then(extractApiData)
}
export const beAccountsApiGetUserById = (idUser = 0) => {
  const url = endpoints.getUserById(idUser)
  return apiWrapper({
    method: 'get',
    url,
  }).then(extractApiData)
}
export const beAccountsApiGetAccountDataRetention = () => {
  const url = endpoints.getAccountDataRetention
  return apiWrapper({
    method: 'get',
    url,
  }).then(extractApiData)
}
export const beAccountsApiGetOptionByShortName = (shortName) => {
  const url = endpoints.getOptionByShortName(shortName)
  return apiWrapper({
    method: 'get',
    url,
  }).then(extractApiData)
}
export const beAccountsApiGetOptions = (options) => {
  const url = endpoints.getOptions
  return apiWrapper({
    method: 'post',
    url,
    headers: {
      'Content-Type': 'application/json',
    },
    data: JSON.stringify({ ShortNames: options }),
  }).then(({ data }) => data)
}
